// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-3_rua container-1avof";
export { _1 as "__esModule", _2 as "container" }
export default { "__esModule": _1, "container": _2 }
